import userStore, { UserStoreT } from './user'
import agentV2Store, { AgentV2StoreT } from './agent-v2'

export interface StoresT {
  userStore: UserStoreT
  agentV2Store: AgentV2StoreT
}

const stores: StoresT = {
  userStore,
  agentV2Store
}

export function getStores(): StoresT {
  return stores
}
